module.exports = __webpack_public_path__ + "static/baked_xmas-5a02afafac8b8ce8b3dc541ff39082d9.jpg";